<div class="unit-selector">
    <ng-container *ngIf="(isLoggedIn$ | async) && !(isLoading$ | async)">
        <mat-label ngClass="labelBeforeSlide">{{ 'unitSelector.title' | cxTranslate }}</mat-label>
        <mat-slide-toggle class="mat-slide-toggle-content" (change)="changed($event)" [color]="red" [hideIcon]="true" [checked]="checked">
        </mat-slide-toggle>
    </ng-container>
</div>